<button class="resetButton" (click)="openDialog()"><ng-content></ng-content></button>
